/* eslint-disable */

// Generated by CoffeeScript 2.5.1
(function() {
  var cloneAndStyle, getStyledSVGasXML, setInlineStyles, swal,
    indexOf = [].indexOf;

  swal = require('sweetalert');

  window.createDownloadElements = function(pdfInstructionsString) {
    var decodedFilter, documentProxyValues, filter, pdfInstructionsJSON, qdtValue, resource, resource_name;
    pdfInstructionsJSON = JSON.parse(decodeURIComponent(pdfInstructionsString));
    if (pdfInstructionsJSON['filter'] != null) {
      decodedFilter = pdfInstructionsJSON['filter'];
      filter = Object.entries(decodedFilter).reduce((acc, [key, value]) => {
        if (typeof value !== "undefined" && value !== "undefined") {
          if (typeof value === "object" && Object.prototype.toString.call(value) !== '[object Array]') {
            return Object.assign({}, acc, {
              [`${key}`]: JSON.stringify(value)
            });
          } else {
            return Object.assign({}, acc, {
              [`${key}`]: value
            });
          }
        } else {
          return acc;
        }
      }, {});
    } else {
      filter = {};
    }
    qdtValue = +pdfInstructionsJSON['qdt'];
    // Some very old lists will have their QuorumDataType set to the
    // old document model proxies. Because we want to trash those to hit the
    // document endpoint, we need to reassign the qdt to be document.
    documentProxyValues = DjangIO.app.models.QuorumDataType.items().filter(function(item) {
      return item.related_field === DjangIO.app.models.QuorumDataType.document.key;
    }).map(function(item) {
      return item.value;
    });
    if (indexOf.call(documentProxyValues, qdtValue) >= 0) {
      qdtValue = DjangIO.app.models.QuorumDataType.document.value;
    } else if (qdtValue === DjangIO.app.models.QuorumDataType.grassroots_action.value) {
      qdtValue = DjangIO.app.models.QuorumDataType.note.value;
    }
    resource_name = DjangIO.app.models.QuorumDataType.by_value(qdtValue).data_model.split(".").last();
    resource = DjangIO.resourceFromDataType(qdtValue);
    return [filter, qdtValue, resource, resource_name];
  };

  window.redirectCSVDownload = function(csvInstructions, title) {
    return $.ajax({
      type: "POST",
      url: "/generatepdf/create_search_csv_download_email/",
      data: {
        data: JSON.stringify({
          details: {
            title: title.stripParenthesis().toTitleCasePreserveAcronyms(),
            api_filter: csvInstructions,
            always_forced_regions: Userdata.current_regions_values
          }
        })
      },
      success: (data) => {
        return console.debug(data);
      },
      error: BACKENDERROR
    });
  };

  window.getStyledHTMLforPagination = function(elementId) {
    var cloneElement, cloneHolder, fontAwsomeLink, htmlString;
    [cloneHolder, cloneElement] = cloneAndStyle(elementId);
    // necessary for WKHTMLTOPDF full page documents
    $(cloneElement).css("margin-left", "-0.225cm");
    // retrieve the html of the clone and remove it
    htmlString = cloneHolder.outerHTML;
    $(cloneHolder).remove();
    fontAwsomeLink = '><link rel="stylesheet" href="https://quorum-static-staging.s3.amazonaws.com/static/css/font-awesome.min.css">';
    return htmlString.replace(">", fontAwsomeLink);
  };

  window.downloadElementAsPDF = function(elementID, title = "PDF - Generated By Quorum") {
    var d, html, url;
    html = getStyledHTMLforPagination(elementID);
    url = "/generatepdf/response_as_pdf/";
    d = $("#download-form");
    $(d).attr('action', url).attr('method', 'post');
    $(d).append($("<input></input>").attr('type', 'hidden').attr('name', 'html').attr('value', html));
    $(d).append($("<input></input>").attr('type', 'hidden').attr('name', 'title').attr('value', title));
    return $(d).submit();
  };

  window.graphSVGDownload = (elementID, title = "Graph - Generated by Quorum", sheetSlug = void 0) => {
    var d, svgXML, url;
    swal('Nice!', 'Your download has begun.', 'success');
    svgXML = getStyledSVGasXML(elementID);
    url = "/generatepdf/download_png/";
    d = $("#download-form");
    $(d).attr('action', url).attr('method', 'post');
    if (sheetSlug) {
      $(d).append($("<input></input>").attr('type', 'hidden').attr('name', 'sheet_slug').attr('value', sheetSlug));
    }
    $(d).append($("<input></input>").attr('type', 'hidden').attr('name', 'data').attr('value', svgXML));
    $(d).append($("<input></input>").attr('type', 'hidden').attr('name', 'title').attr('value', title));
    return $(d).submit();
  };

  getStyledSVGasXML = function(elementId) {
    var cloneElement, cloneHolder, prefix, svgXML;
    [cloneHolder, cloneElement] = cloneAndStyle(elementId);
    prefix = {
      xmlns: "http://www.w3.org/2000/xmlns/",
      xlink: "http://www.w3.org/1999/xlink",
      svg: "http://www.w3.org/2000/svg"
    };
    cloneHolder.setAttribute("version", "1.1");
    if (!cloneHolder.hasAttributeNS(prefix.xmlns, "xmlns")) {
      cloneHolder.setAttributeNS(prefix.xmlns, "xmlns", prefix.xmlns);
    }
    if (!cloneHolder.hasAttributeNS(prefix.xmlns, "xmlns:xlink")) {
      cloneHolder.setAttributeNS(prefix.xmlns, "xmlns:xlink", prefix.xlink);
    }
    $(cloneHolder).find("text").each(function() {
      $(this).css("font-family", "'Helvetica Neue', Helvetica, Arial, sans-serif");
      if (!elementId.includes("wordCloud")) {
        return $(this).css("font-size", "13.5px");
      }
    });
    svgXML = (new XMLSerializer()).serializeToString(cloneHolder);
    // htmlString = cloneHolder.outerHTML
    // return htmlString
    $(cloneHolder).remove();
    return svgXML;
  };

  cloneAndStyle = function(elementId) {
    var cloneElement, cloneHolder, computedStyles, target;
    //get the target element
    target = $(`#${elementId.replace(/^#+/i, '')}`)[0];
    //append a clone of the element to its parent
    $(target).parent().append("<div id='clone-holder'></div>");
    $(target).clone().addClass("clone").appendTo("#clone-holder");
    cloneHolder = $("#clone-holder")[0];
    // explicitly set inline styling of cloned element
    computedStyles = getComputedStyle(cloneHolder);
    setInlineStyles(cloneHolder, computedStyles);
    cloneElement = $(".clone")[0];
    return [cloneHolder, cloneElement];
  };

  setInlineStyles = function(htmlElement, styles) {
    var allElements, explicitlySetStyle, i, reservedTerms, results, traverse;
    // traverses an html element through all children and sets explicit styles

    // WKHTMLTOPDF has a hard time handling certain css rules
    // these terms can increase both file size and download time significantly
    // they should not be applied to the html that will be converted
    reservedTerms = ['opacity'];
    explicitlySetStyle = function(element) {
      var computedStyleString, i, key, styleDeclaration, value;
      styleDeclaration = getComputedStyle(element);
      i = 0;
      computedStyleString = "";
      while (i <= styleDeclaration.length) {
        key = styleDeclaration[i];
        value = styleDeclaration.getPropertyValue(key);
        if (value !== styles.getPropertyValue(key) && indexOf.call(reservedTerms, key) < 0) {
          computedStyleString += key + ":" + value + ";";
        }
        i += 1;
      }
      return element.setAttribute('style', computedStyleString);
    };
    traverse = function(obj) {
      var tree, visit;
      visit = function(node) {
        var child, results;
        if (node && node.hasChildNodes()) {
          child = node.firstChild;
          results = [];
          while (child) {
            if (child.nodeType === 1 && child.nodeName !== 'SCRIPT') {
              tree.push(child);
              visit(child);
            }
            results.push(child = child.nextSibling);
          }
          return results;
        }
      };
      tree = [];
      tree.push(obj);
      visit(obj);
      return tree;
    };
    allElements = traverse(htmlElement);
    i = allElements.length;
    results = [];
    while (i--) {
      results.push(explicitlySetStyle(allElements[i]));
    }
    return results;
  };

}).call(globalThis);
